import { action, computed, observable } from 'mobx';
import GlobalStore from '@/store/GlobalStore';
import {checkWelfare, getWelfare} from '@/services/welfare';
import router from '@/router';
import log from '@/utils/log';

class WelfareStore {
  
  @observable successTips: string[] = []
  
  @observable pickStatus = 0 // 0未领取 1已领取 2领取成功
  
  @observable toast = GlobalStore.toast
  
  @action.bound async checkWelfare (openId) {
    
    if (sessionStorage.getItem('isWeixinCent') === 'false') {
      this.toast.text('请在微信中打开领取')
      await log.logRequest({eventId: 'N1001' })
      return
    }
  
    if (!openId) {
      this.toast.text('获取用户信息失败')
      await log.logRequest({eventId: 'N1002' })
      return
    }
  
    const response = await checkWelfare({openId})
    
    if (response.code === 60007) { // 已绑定未领取
      this.getWelfare(openId)
      await log.logRequest({eventId: 'N1003' })
      return false
    }
    
    if (response.code === 60002) { // 未绑定
      this.toast.text('请绑定账号后再领取')
      await log.logRequest({eventId: 'N1004' })
      router.push({path: 'bindUser?source=welfare'})
      return
    }
    
    if (response.code === 60008) { // 已领取
      this.toast.text('您已领取过该奖励')
      this.pickStatus = 1;
      await log.logRequest({eventId: 'N1005' })
      return
    }
    this.toast.text(response.msg)
  
  }
  
  @action.bound async getWelfare (openId) {
  
    const response = await getWelfare({openId})
    
  
    if (response.code === 10000) {
      await log.logRequest({eventId: 'N1006' })
      this.pickStatus = 2;
      response.result.map((item) => {
        if (item.type === 2) {
          this.successTips = this.successTips.concat([ `${(item.value*10).toFixed(1)}折打折卡${item.count}张`])
        } else {
          this.successTips = this.successTips.concat (`${item.value}元代金券${item.count}张`)
        }
      })
      return
    }
    
    const errorMess = {
      '60002' : '帐号未绑定',
      '60008': '已经领取过'
    }
  
    this.toast.text(errorMess[String(response.code)])
  
  }
  
  
}

export default new WelfareStore();
